<template>
  <LoadingContainer
    :is-loaded="isLoaded"
    :total="presetTotal"
    kind="Preset"
  >
    <form class="create-activity form" @submit.prevent="saveActivity" slot="default">
      <SubjectPicker v-model="overrideSubject" />

      <StudentPicker v-model="preset.student" />

      <label class="form__label" for="date">Date</label>
      <input
        id="date"
        class="form__input"
        name="date"
        type="date"
        v-model="formattedDate"
      />

      <label class="form__label" for="description">Description</label>
      <input
        id="description"
        class="form__input"
        name="description"
        type="text"
        v-model="preset.description"
      />

      <DurationPicker v-model="preset.duration" />

      <button type="submit" class="form__submit">Save</button>
    </form>
  </LoadingContainer>
</template>

<script>
import store from '@/store'

import { mapGetters } from 'vuex'

export default {
  name: 'CreateActivity',

  props: {
    date: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      formattedDate: ''
    }
  },

  computed: {
    ...mapGetters({
      presets: 'presets/sortedPresets'
    }),

    isLoaded () {
      return !!(this.preset && this.preset.id)
    },

    presetId () {
      return this.$route.params.presetId
    },

    preset () {
      const preset = this.presets.find(p => p.id === this.presetId)

      return preset || {}
    },

    presetTotal () {
      return Object.keys(this.preset).length
    },

    subjectId () {
      return this.$route.params.subjectId
    },

    activity () {
      return {
        ...this.preset
      }
    },

    overrideSubject () {
      return this.subjectId
        ? [this.subjectId]
        : this.preset.subject
    }
  },

  methods: {
    saveActivity () {
      const {
        id,
        ...activity
      } = this.activity

      activity.date = this.formattedDate

      this.$emit('saved', activity)
    }
  },

  mounted () {
    this.formattedDate = this.date

    store.dispatch('presets/getPresets')
  }
}
</script>
